import React, { useEffect, useState } from 'react'
import './ChimeParticipantsListView.scss';
import { RosterAttendeeType, useRosterState } from 'amazon-chime-sdk-component-library-react';
import { useChimeMeeting } from '../../../Chime/ChimeMeetingContext';
import ParticipantCard from './ParticipantCard';

const ChimeParticipantsListView = () => {

    const { attendeeId, hostId, muteAll, isHandRaised, participantsRef, participantList, setParticipantsList, userId } = useChimeMeeting();
    const { roster } = useRosterState();
    const [participantsCount,setParticipantsCount] = useState<number>(0);
    const [allAttendeeData, setAllAttendeeData] = useState<any>([]);

    useEffect( () => {
        if(roster && attendeeId){
          const attendeeKeys = Object.keys(roster);
          const temp :any[] = [];
          const partTemp: any = {};
          const results = attendeeKeys.map( (id: any ) => { 
              const attendeeData = roster[id] as RosterAttendeeType & { color: string };
              partTemp[id] = {attendeeData, handRaised: participantsRef.current[id]?.handRaised ?? false};
              console.log('attendee data inside the loop=====>',attendeeData);
              if(attendeeData?.chimeAttendeeId !== attendeeId && 
                !attendeeData?.externalUserId?.includes("aws:MediaPipeline") && 
                attendeeData?.externalUserId &&  
                attendeeData?.chimeAttendeeId && attendeeData?.name){
                  temp.push({
                      chimeAttendeeId : attendeeData?.chimeAttendeeId,
                      externalUserId: attendeeData?.externalUserId,
                      name: attendeeData?.name,
                      handRaised: participantsRef.current[attendeeData?.chimeAttendeeId]?.handRaised ?? false,
                      color: attendeeData?.color || '#bdbdbd'
                  });
              }
          });
          console.log("[Log] Roster attendees data: ", results);
          setParticipantsList(temp);
        }
      }, [roster]);

    // Separate the host and other participants
    const currentAttendeeData = roster && Object.values(roster).find(
        (participant) => participant.chimeAttendeeId === attendeeId
    );

    const host: any = participantList && participantList.find(
        (participant: any) => participant?.externalUserId === hostId
    );

    useEffect(() => {
        setAllAttendeeData(participantList && participantList?.filter(
            (participant: any) => participant?.externalUserId !== hostId
        ));
        const count = participantList?.length + ( currentAttendeeData ? 1 : 0 );
        setParticipantsCount(count);
    }, [participantList])

   return (
    <div className='participantsListContainer'>
        <div className='header-style'>
            <div className='participantCTAStyle'>
                <div className='header-left-style'>
                    {`Participants`}
                </div>
               {userId === hostId &&  <button className='ctastyle' onClick={() => muteAll()}>
                    Mute All
                </button>}
            </div>
            <div className='header-right-style'>
                {`${participantsCount ? participantsCount : 1}`}
            </div>
        </div>
        <div className='participantsList'>
            {
                host && 
                    <ParticipantCard
                        key={host?.chimeAttendeeId}
                        participant={host}
                        isHostParticipant={host?.externalUserId === hostId}
                        isHandRaised={host?.handRaised}
                    />
            }
            {
                currentAttendeeData && 
                    <ParticipantCard
                        key={currentAttendeeData?.chimeAttendeeId}
                        participant={currentAttendeeData}
                        isHostParticipant={userId === hostId}
                        isHandRaised={isHandRaised}
                    />
            }
            {
                allAttendeeData && allAttendeeData?.map((user: any, index: number) => {
                    return(
                        <ParticipantCard
                            key={user?.chimeAttendeeId}
                            participant={user}
                            isHostParticipant={user?.externalUserId === hostId}
                            isHandRaised={user?.handRaised}
                        />
                    );
                })
            }
           
        </div>
    </div>
  )
}

export default ChimeParticipantsListView;
